import { gql, useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import IsoToDateTime, { IsoToDateWithoutTime } from "../../../CommonFunction/IsoDateTime";
import { LoadTable, Loading } from "../../Components";
import { Tabs } from "../../Components/AdminRequestSupportComponents/Tabs";
import SearchBoxesDiv from "../../Components/HeaderDiv/HeaderDivComponents/SearchBoxesDiv/SearchBoxesDiv";
import useFetchTableData from "../../custom_hooks/useFetchTableData";
import CloseShipMentTrack from "../MyShipmentTrackings/CloseShipMent";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";

const queryFunction = (fields) => {
  const query = gql`
    query GetAllTripTracks($isLive: Boolean) {
        getAllTripTracks(Is_Live: $isLive) {
        _id
        ${fields?.join(" ")}
      }
    }
  `;
  return query;
};

const getCategoryFromTab = (tab) => {
  switch (tab) {
    case "Live":
      return { isLive: true };
    case "Closed":
      return { isLive: false };
    case "All":
      return {};
    default:
      return {};
  }
};

const ShipmentTrackBoard = () => {
  const Key = "Shipment_Tracking";
  const [showCloseModal, setShowCloseModal] = useState(false);
  const [LoadId, setLoadId] = useState("");
  const [formdata, setformdata] = useState(null);
  const [Tab, SetTab] = useState("Live");
  const [loadingState, setLoading] = useState(true);
  const dispatch = useDispatch();
  const ReduxData = useSelector((store) => store?.UniqueTableReducer);
  const fielddata = ReduxData[Key]?.Selected_Row;

  const [fetchAllLoad, { loading, error, data }] = useLazyQuery(queryFunction([]), {
    variables: getCategoryFromTab(Tab),
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },

    onCompleted: () => {
      setLoading(false);
    },
    onError: () => {
      setLoading(false);
    },
  });

  let statusTab = [{ name: "Live" }, { name: "Closed" }, { name: "All" }];

  const closeFunction = () => {
    setShowCloseModal(true);
    setLoadId(fielddata.tripId);
  };

  useEffect(() => {
    const Tabdata = {
      key: Key,
      data: Tab,
    };
    dispatch({ type: "UNIQUE_TAB_SELECT", payload: Tabdata });
    dispatch({ type: "Refetch", payload: true }); // Trigger the lazy query when
  }, [Tab]);

  useEffect(() => {
    if (data?.getAllTripTracks) {
      let updatedData = data?.getAllTripTracks?.map((el) => {
        let obj = { ...el };
        delete obj.__typename;
        if (obj?.Date) {
          obj.Date = IsoToDateTime(obj?.Date);
        }
        if (obj?.createdAt) {
          obj.createdAt = IsoToDateTime(obj?.createdAt);
        }
        if (obj?.updatedAt) {
          obj.updatedAt = IsoToDateTime(obj?.updatedAt);
        }
        if (obj?.Loading_Date) {
          obj.Loading_Date = IsoToDateWithoutTime(obj?.Loading_Date);
        }
        return obj;
      });
      setformdata(updatedData);
      setLoading(false);
    }
  }, [data]);

  const { TableHeaders } =useFetchTableData(queryFunction, fetchAllLoad, setLoading, Key);
  console.log(loading, data, "ShipmentTrackingPage");
  return (
    <div className="LoadContainer">
      {/* <div className="HeaderDiv">
        <div>
          <p className="pageTitle">Shipment Tracking</p>
          <div className="hr1ForPageTitle"></div>
        </div>
        <SearchBoxesDiv />
      </div> */}
      <HeaderDiv TableKey={Key} title="Shipment Tracking" closeFun={closeFunction} />
      <Tabs tabs={statusTab} SetTabPage={SetTab} MoreActions={{Is_Close:true}} />
      {/* {loading || loadingState ? (
        <Loading />
      ) : !formdata?.length ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <>
          <LoadTable
            title={Key}
            data={formdata}
            loading={loading}
            error={error}
            ledgerTable={undefined}
            selectedRows={undefined}
            Tab={Tab}
          />

          {showCloseModal && (
            <CloseShipMentTrack
              show={showCloseModal}
              tripId={LoadId}
              setShowModal={() => setShowCloseModal(!showCloseModal)}
              fetchAllLoad={fetchAllLoad}
            />
          )}
        </>
      )} */}

      {loading && (!formdata || formdata.length === 0) && <Loading />}
      {!loading && (!formdata || formdata.length === 0) && <p className="DataNotAvailable">Data not Available</p>}
      {formdata && formdata.length > 0 && (
        <>
          {/* 4) If re-fetching (loading again) but we already have data, show inline loader */}
          {loading && <div className="loader-line-div" />}

          <LoadTable data={formdata} loading={""} error={error} title={Key} Tab={Tab} TableHeaders={TableHeaders} />

          {showCloseModal && (
            <CloseShipMentTrack
              show={showCloseModal}
              tripId={LoadId}
              setShowModal={() => setShowCloseModal(!showCloseModal)}
              fetchAllLoad={fetchAllLoad}
            />
          )}
        </>
      )}
    </div>
  );
};

export default ShipmentTrackBoard;
